import type { ContratApprentissageDTO } from '@/features/api/extranet/dto/Demande/CAPP'
import { getAge, isDate } from '@/features/shared/tools'

import { getDureeContratMois } from './tools'
import { nafAutoriseTT } from '../shared'

export * from '@/features/domaine/regles-akto/shared/preconditions'

/* Sépcifiques métier */
export const preNafTT = (_value: any, _parent: any, modele: ContratApprentissageDTO) =>
  modele?.employeur?.etablissement?.naf?.code === nafAutoriseTT
export const preMineur = (_value: any, _parent: any, modele: ContratApprentissageDTO) =>
  isDate(modele.apprenti?.dateNaissance) &&
  isDate(modele.contrat?.dateConclusion) &&
  getAge(new Date(modele.apprenti.dateNaissance), new Date(modele.contrat.dateConclusion)) < 18
export const preMajeur = (_value: any, _parent: any, modele: ContratApprentissageDTO) =>
  isDate(modele.apprenti?.dateNaissance) &&
  isDate(modele.contrat?.dateConclusion) &&
  getAge(new Date(modele.apprenti.dateNaissance), new Date(modele.contrat.dateConclusion)) >= 18
export const preMoins16Ans = (_value: any, _parent: any, modele: ContratApprentissageDTO) => {
  if (!isDate(modele.apprenti?.dateNaissance) || !isDate(modele.contrat?.dateConclusion)) return false
  const age = getAge(new Date(modele.apprenti.dateNaissance), new Date(modele.contrat.dateConclusion))
  return age >= 15 && age < 16
}
export const preNotNirTemporaire = (_value: any, _parent: any, modele: ContratApprentissageDTO) =>
  modele.apprenti?.nirTemporaire !== true
export const preNirTemporaire = (_value: any, _parent: any, modele: ContratApprentissageDTO) =>
  modele.apprenti?.nirTemporaire !== true
export const preNirTemporaireNon = (_value: any, _parent: any, modele: ContratApprentissageDTO) =>
  modele.apprenti?.nirTemporaire === false
export const preContratMoins6Moins = (value: any, _parent: any, modele: ContratApprentissageDTO) =>
  isDate(modele.contrat?.dateDebutExecutionContrat) &&
  getDureeContratMois(new Date(modele.contrat.dateDebutExecutionContrat), new Date(value!)) < 6
export const preContratPlus36Moins = (value: any, _parent: any, modele: ContratApprentissageDTO) =>
  isDate(modele.contrat?.dateDebutExecutionContrat) &&
  getDureeContratMois(new Date(modele.contrat.dateDebutExecutionContrat), new Date(value!)) > 36


/* Archives */
/*
export const preDateNaissance = (_value: any, _parent: any, modele: ContratApprentissageDTO) =>
  isDate(modele.apprenti?.dateNaissance)
export const preDateConclusion = (_value: any, _parent: any, modele: ContratApprentissageDTO) =>
  isDate(modele.contrat?.dateConclusion)

export const preTypeDerogationNot11And12 = (value: any) => value !== '11' && value !== '12'
export const preDateDebutExecutionContrat = (_value: any, _parent: any, modele: ContratApprentissageDTO) =>
  isDate(modele?.contrat?.dateDebutExecutionContrat)

export const preDateFinContratOuPeriodeApprentissage = (_value: any, _parent: any, modele: ContratApprentissageDTO) =>
  isDate(modele?.contrat?.dateFinContratOuPeriodeApprentissage)

export const preDateFinFormation = (_value: any, _parent: any, modele: ContratApprentissageDTO) =>
  isDate(modele?.formation?.datePrevueFinEpreuvesOuExamens)
export const preNirApprentiNotNullOrEmpty = (_value: any, _parent: any, modele: ContratApprentissageDTO) =>
  modele.apprenti?.nir !== null && modele.apprenti?.nir !== undefined && modele.apprenti?.nir !== ''
*/

